import { useQuery } from '@apollo/client'
import { getNote as getNoteGql }
   from 'src/graphql/queries/getNote.gql'

const useNote = (variables, options = {}) => {
   const { data, ...otherQueryResults } = useQuery(getNoteGql, {
      variables,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   return {
      note: data?.note,
      ...otherQueryResults
   }
}

export default useNote
